<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
    >
        <button uilabMatIconButton [attr.aria-label]="example.label">
            <uilab-mat-icon [svgIcon]="ICONS.homeFilled"></uilab-mat-icon>
        </button>
    </avd-code-example>
}
